import { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../../components/basics/Loading";
import { BoletoGrid } from "./children/BoletoGrid";
import { CompanyInfo } from "./children/CompanyInfo";

import Support from "./children/Support";
import { BoletoContext } from "./contexts/BoletoContext";
import useBilletController from "./controllers/BoletoController";
import { Container, MainGrid } from "./styles/Boleto";

const View = () => {
  const {
    contractData,
    billetData,
    empresaCnpj,
    companyName,
    companyLogoUrl,
    isPageLoading,
    setPageLoading,
    token,
  } = useContext(BoletoContext);
  const { fetchBilletData, getComapanyData } = useBilletController();

  const { goBack } = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      if (empresaCnpj) {
        if (!contractData && !billetData.length && !companyName) {
          await fetchBilletData();
          await getComapanyData();
          setPageLoading(false);
        }
      } else {
        goBack();
      }
    };
    fetchData();
  }, [
    billetData,
    companyName,
    contractData,
    empresaCnpj,
    fetchBilletData,
    getComapanyData,
    goBack,
    setPageLoading,
    token,
  ]);

  return (
    <>
      <Loading open={isPageLoading} />
      <Container>
        <MainGrid>
          <CompanyInfo
            companyCnpj={empresaCnpj}
            companyLogoUrl={companyLogoUrl}
            companyName={companyName}
          />

          <BoletoGrid />
          <Support />
        </MainGrid>
      </Container>
    </>
  );
};

const Listagem = () => <View />;

export default Listagem;
